export type WorkspaceType =
  | 'overview'
  | 'agent'
  | 'documents'
  | 'investigate'
  | 'monitor'
  | 'report'

export type ViewType =
  | 'investigate-overview'
  | 'knowledge-graph'
  | 'graph'
  | 'documents'
  | 'geolocation'
  | 'time-axis'
  | 'entity-resolution'
  | 'identity'

/** Context passed by CaseLayout to its routed sub-pages via <Outlet context>. */
export interface CaseOutletContext {
  navigateToView: (type: ViewType) => void
  handleViewGeoData: (documentId: string) => void
  handleWorkspaceChange: (workspace: WorkspaceType) => void
}

/** Map a `/cases/:id/<seg>` pathname to its active workspace + view type. */
export function deriveFromPath(pathname: string): { workspace: WorkspaceType; viewType: ViewType } {
  const seg = pathname.match(/\/cases\/[^/]+\/([^/?#]+)/)?.[1] ?? 'overview'
  switch (seg) {
    case 'knowledge-graph':
    case 'explore-graph':
      return { workspace: 'investigate', viewType: 'knowledge-graph' }
    case 'graph':
    case 'graph-views':
      return { workspace: 'investigate', viewType: 'graph' }
    case 'entity-resolution':
      return { workspace: 'investigate', viewType: 'entity-resolution' }
    case 'identity':
      return { workspace: 'investigate', viewType: 'identity' }
    case 'geolocation':
      return { workspace: 'investigate', viewType: 'geolocation' }
    case 'time-axis':
      return { workspace: 'investigate', viewType: 'time-axis' }
    case 'insights':
    case 'investigate':
      return { workspace: 'investigate', viewType: 'investigate-overview' }
    case 'structured-ingest':
      return { workspace: 'investigate', viewType: 'documents' }
    case 'documents':
    case 'extraction-runs':
      return { workspace: 'documents', viewType: 'documents' }
    case 'report':
    case 'case-summary':
    case 'evidence':
    case 'audit':
      return { workspace: 'report', viewType: 'documents' }
    case 'monitor':
      return { workspace: 'monitor', viewType: 'documents' }
    case 'agent':
      return { workspace: 'agent', viewType: 'documents' }
    default:
      return { workspace: 'overview', viewType: 'documents' }
  }
}
